export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: "日本一区具体包括哪些地方？",
    answer: "日本一区通常指以东京为核心的关东地区主要城市圈，包括东京都（23区及多摩地区）、神奈川县（横滨市、川崎市等）、埼玉县（埼玉市等）、千叶县（千叶市等）以及茨城县南部部分地区。这是日本人口最密集、经济最发达的区域。",
  },
  {
    question: "日本二区的核心城市有哪些？",
    answer: "日本二区以关西地区为核心，主要包括大阪府（大阪市）、京都府（京都市）、兵库县（神户市）、奈良县（奈良市）、滋贺县（大津市）以及和歌山县部分地区。大阪是商业中心，京都是文化古都，神户是国际港口城市，三城构成关西黄金三角。",
  },
  {
    question: "一区和二区在气候上有什么区别？",
    answer: "一区（关东）夏季炎热潮湿，冬季较为干燥寒冷，偶尔降雪；二区（关西）夏季同样炎热，但冬季相对温和。两区域在6月至7月均会经历梅雨季。一区的太平洋沿岸冬季日照充足，被称为'冬晴'；京都因盆地地形冬季较为寒冷，被称为'底冷え'。",
  },
  {
    question: "从一区到二区最方便的交通方式是什么？",
    answer: "从东京（一区）到大阪（二区），东海道新干线是最佳选择，最快约2小时30分钟。班次非常密集，白天时段每3-5分钟就有一班。如果预算有限，夜行巴士（约8-9小时）和国内航班也是可行的选择。推荐购买JR Pass周游券，可在指定期限内无限次乘坐。",
  },
  {
    question: "生活在一区和二区的成本差距有多大？",
    answer: "以单身人士月均生活支出计算，一区（东京）约为15-20万日元（不含租金），二区（大阪）约为12-16万日元。房租差距最大，东京中心的1LDK月租约15-25万日元，大阪中心约8-15万日元。综合来看，在二区生活整体成本约比一区低25%-35%。",
  },
  {
    question: "一区和二区哪个更适合留学？",
    answer: "这取决于个人的学习目标和偏好。一区拥有东京大学、早稻田大学等顶尖学府，适合追求学术资源最大化和国际视野的学生；二区拥有京都大学、大阪大学等研究实力雄厚的大学，且生活成本较低、文化氛围更温和。从性价比角度看，二区对预算有限的留学生更具吸引力。",
  },
];